import { render, staticRenderFns } from "./EditRoleDialog.vue?vue&type=template&id=5a37e208&scoped=true"
import script from "./EditRoleDialog.vue?vue&type=script&lang=js"
export * from "./EditRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37e208",
  null
  
)

export default component.exports